import { MemberExperienceUserFromIdToken } from '@guildeducationinc/auth-frontend-tools';
import { Answers, ScreenGroups, Screens } from './types';
import { QuizMappingType, defaultScreenMap } from './screenMapping';

export const getScreensFromScreenGroup = (
	screenGroup: ScreenGroups,
	screenMapping: QuizMappingType
) => {
	return Object.keys(screenMapping).reduce((screensInCurrentGroup, currentScreen) => {
		if (screenMapping[currentScreen].screenGroup === screenGroup) {
			screensInCurrentGroup.push(currentScreen);
		}
		return screensInCurrentGroup;
	}, []);
};

export const getFirstScreenOfNextScreenGroup = (
	screenGroupOrder: ScreenGroups[],
	screen: string
) => {
	const currentScreenGroup = defaultScreenMap[screen].screenGroup;
	const indexOfCurrentScreenGroup = screenGroupOrder.indexOf(currentScreenGroup);
	const nextScreenGroup = screenGroupOrder[indexOfCurrentScreenGroup + 1];
	return getScreensFromScreenGroup(nextScreenGroup, defaultScreenMap)[0];
};

export const getNextScreen = (
	answers: Answers,
	employer: MemberExperienceUserFromIdToken['employer_uuid'],
	currentScreen: Screens,
	screenMapping: QuizMappingType
) => {
	const nextScreen = screenMapping[currentScreen].nextScreen;

	if (currentScreen === Screens.WELCOME_1) {
		return nextScreen[employer] || nextScreen.default;
	}
	if ([Screens.GOAL, Screens.HS_GPA, Screens.COLLEGE_GPA].includes(currentScreen)) {
		return nextScreen[answers.education] || nextScreen.default;
	}

	if (currentScreen === Screens.INTERESTS) {
		return answers.interests.includes('Technology')
			? nextScreen.Technology
			: answers.interests.includes('Business')
				? nextScreen.Business
				: answers.interests.includes('Healthcare')
					? nextScreen.Healthcare
					: nextScreen.default;
	}

	if (currentScreen === Screens.TECH_INTERESTS) {
		return answers.interests.includes('Business')
			? nextScreen.Business
			: answers.interests.includes('Healthcare')
				? nextScreen.Healthcare
				: nextScreen.default;
	}

	if (currentScreen === Screens.BUSINESS_INTERESTS) {
		return answers.interests.includes('Healthcare') ? nextScreen.Healthcare : nextScreen.default;
	}

	return nextScreen.default;
};
